
export const datastore = {
  data: {
    affiliatePartnerId: "",
    token: "",
    userType: ""
  },
};
